import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function PresenceStrip() {
  const [presence, setPresence] = useState(null);
  const [steamCount, setSteamCount] = useState(null);

  useEffect(() => {
    let guestId = localStorage.getItem("nc_guest");
    if (!guestId) {
      guestId = crypto.randomUUID();
      localStorage.setItem("nc_guest", guestId);
    }
    const beat = () => api.post("/presence/heartbeat", { guestId }).catch(() => {});
    const fetchPresence = () => api.get("/presence").then((r) => setPresence(r.data)).catch(() => {});
    const fetchSteam = () => api.get("/steam/player-count").then((r) => { if (r.data.count != null) setSteamCount(r.data.count); }).catch(() => {});
    beat();
    fetchPresence();
    fetchSteam();
    const beatTimer = setInterval(beat, 25000);
    const fetchTimer = setInterval(fetchPresence, 15000);
    const steamTimer = setInterval(fetchSteam, 60000);
    return () => { clearInterval(beatTimer); clearInterval(fetchTimer); clearInterval(steamTimer); };
  }, []);

  if ((!presence || presence.online === 0) && steamCount == null) return null;

  const watching = [
    ...(presence?.citizens || []),
    ...(presence?.guests > 0 ? [`+${presence.guests} guest${presence.guests > 1 ? "s" : ""}`] : []),
  ].join(", ");

  return (
    <div data-testid="presence-strip" className="border-b border-white/10 bg-black/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2.5 flex items-center gap-3 overflow-hidden">
        <span className="w-2 h-2 bg-nc-green animate-pulse shrink-0" style={{ boxShadow: "0 0 10px rgba(0, 230, 118, 0.6)" }} />
        <span data-testid="presence-count" className="font-mono text-[10px] tracking-[0.25em] text-nc-green uppercase shrink-0">
          {presence?.online ?? 0} Online
        </span>
        <span data-testid="presence-names" className="font-mono text-[10px] tracking-[0.15em] text-zinc-500 uppercase truncate">
          {watching}
        </span>
        {steamCount != null && (
          <span data-testid="steam-player-count" className="font-mono text-[10px] tracking-[0.25em] text-zinc-300 uppercase shrink-0 ml-auto border border-white/10 bg-white/5 px-2.5 py-1 flex items-center gap-2">
            <span className="w-1.5 h-1.5 bg-nc-blue animate-pulse" />
            {steamCount} In-Game on Steam
          </span>
        )}
      </div>
    </div>
  );
}
